import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";

interface UpdateUserDto {
    fcmKey?: string | null;
}

@Injectable({providedIn: 'root'})
export class UserService {
    private readonly http = inject(HttpClient);

    public updateUser(update: UpdateUserDto) {
        return this.http.patch(`${environment.apiServerUrl}/user`, update)
    }

}